import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useProject(userID, projectId) {
  const { data, _error, isLoading, isValidating, mutate } = useSWR(
    userID ? `/projects/${projectId}` : null,
    (url) => fetcher(url),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  return {
    project: data,
    isLoading,
    isValidating,
    mutate: mutate,
  };
}

export default useProject;
